import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=38855966&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports